import { render, staticRenderFns } from "./ChallengeForm.vue?vue&type=template&id=208eb2e9&"
import script from "./ChallengeForm.vue?vue&type=script&lang=js&"
export * from "./ChallengeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports